export default __webpack_public_path__ + "static/media/servier-logo-new.00c48147.png";